import { gql } from "@stadium/services/apollo-client";

export const fetchSavedCreditCardsAndWaletInfo = gql`
  query fetchSavedCreditCardsAndWaletInfo($skipCreditCards: Boolean!, $skipWallets: Boolean = false)
  @api(name: "users") {
    creditCards @skip(if: $skipCreditCards) {
      id
      name
      month
      year
      default
      ccType
      lastDigits
      default
    }
    teams @skip(if: $skipWallets) {
      id
      name
      currencyCode
      myWalletBalance
      currentUserRole
      defaultTeam
    }
  }
`;
